/**
* DevExpress Dashboard (_widget-item-factory.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import dxChart from 'devextreme/viz/chart';
import dxCircularGauge from 'devextreme/viz/circular_gauge';
import dxLinearGauge from 'devextreme/viz/linear_gauge';
import dxPieChart from 'devextreme/viz/pie_chart';
function getAdditionalCircularGaugeOptions(container, options) {
    return null;
}
var getAdditionalOptionsHandlers = {
    'circulargauge': getAdditionalCircularGaugeOptions
};
export const defaultWidgetsMap = {
    'chart': dxChart,
    'piechart': dxPieChart,
    'circulargauge': dxCircularGauge,
    'lineargauge': dxLinearGauge
};
let widgetsMap = { ...defaultWidgetsMap };
export let widgetItemFactory = {
    createWidget: function (widgetType, container, options) {
        const normalizedWidgetType = (widgetType || '').toLowerCase();
        const widget = widgetsMap[normalizedWidgetType];
        if (!widget) {
            return null;
        }
        let widgetInstance = widget.getInstance(container);
        if (widgetInstance) {
            widgetInstance.option(options);
        }
        else {
            widgetInstance = new widget(container, options);
        }
        return widgetInstance;
    },
    getAdditionalOptions: function (widgetType, container, options) {
        var handler = getAdditionalOptionsHandlers[(widgetType || '').toLowerCase()];
        return handler ? handler(container, options) : null;
    },
    __resetFactory: function () {
        widgetsMap = { ...defaultWidgetsMap };
    },
    __replaceWidget: function (widgetName, newWidget) {
        widgetsMap[widgetName] = newWidget;
    }
};
